// extracted by mini-css-extract-plugin
export default {"rowImage":"UserImage_rowImage__s5MRy","img":"UserImage_img__ZJ+Ez"};